var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeftFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 26 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.414 11.317v1.552H4.373l4.121 4.143-1.1 1.094-5.98-6.013L7.407 6l1.107 1.094-4.161 4.223h21.06Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeftFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ArrowLeftFilled.8600153564876f001c184848fccca585.svg";